<template>
  <vxe-grid
    ref="table"
    border
    height="450"
    :checkbox-config="{
      highlight: true,
      reserve: true,
      checkRowKeys: checkRowKeys,
    }"
    :data="tableData"
    :columns="tableColumns"
    row-id="roleID"
    size="small"
    :cell-class-name="cellClassName"
    :header-cell-class-name="headerCellClassName"
  >
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data">
          {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
export default {
  props: {
    userCode: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
      tableColumns: [
        {
          field: "seq",
          width: 50,
          align: "center",
          fixed: "left",
          type: "seq",
        },
        {
          field: "checkbox",
          width: 40,
          align: "center",
          fixed: "left",
          type: "checkbox",
        },
        {
          title: this.$l("form_label_role_name") || "角色名称",
          field: "roleName",
          minWidth: 150,
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
          sortable: true,
          sortType: "string",
        },
      ],
      checkRowKeys: [],
    };
  },
  activated() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.checkRowKeys = [];
      this.$api.sysUserRoleListApi({ userCode: this.userCode }).then((res) => {
        const { data } = res.body;
        this.tableData = data;

        data.forEach((item) => {
          if (item.permission === "Y") this.checkRowKeys.push(item.roleID);
        });
      });
    },
    getTableData() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords();
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords();

      const tableData = reserveRecords.concat(selectRecords);
      return tableData;
    },
    headerCellClassName({ columnIndex }) {
      if (this.disabled) {
        if (columnIndex === 1) {
          return "disabled_checkBox";
        }
      }
    },
    cellClassName({ columnIndex }) {
      if (this.disabled) {
        if (columnIndex === 1) {
          return "disabled_checkBox";
        }
      }
    },
  },
};
</script>
<style>
.disabled_checkBox {
  pointer-events: none;
}
</style>
